import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { ICardDef } from './card-def';

const NavIcon = (props: { icon: string }) => (
    <img src={props.icon} style={{ width: 48, height: 48, objectFit: 'contain' }} />
);

interface IProps {
    card: ICardDef
}

const ComplianceCard = ({ card }: IProps) => {
    const [hovered, setHovered] = useState(false);

    return (
        <div
            style={{ position: 'relative', borderRadius: 8, minHeight: 250, cursor: 'pointer', minWidth: 200, display: 'flex' }}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            {/* Base card */}
            <div style={{
                backgroundColor: card.bgColor,
                borderRadius: 8,
                padding: '25px 15px 15px',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-between',
                flex: 1
            }}>
                <div>
                    <div style={{ marginBottom: 10 }}>
                        <NavIcon icon={card.icon} />
                    </div>
                    <div style={{ color: 'rgba(255,255,255,1)', fontSize: 16, fontWeight: 700, textAlign: 'center', marginBottom: 4 }}>
                        {card.title}
                    </div>
                    {card.subtitle && (
                        <div style={{ color: 'rgba(255,255,255,0.75)', fontSize: 16, fontWeight: 400, textAlign: 'center' }}>
                            {card.subtitle}
                        </div>
                    )}
                </div>
                <Button
                    style={{
                        width: 172,
                        height: 34,
                        borderRadius: 5,
                        backgroundColor: 'rgba(255, 255, 255, 1)',
                        color: card.bgColor,
                        border: 'none',
                        fontWeight: 500, marginTop: 14
                    }}
                    onClick={card.action}>Click to View Document</Button>
            </div>

            {/* Hover overlay */}
            {hovered && (
                <div style={{
                    position: 'absolute',
                    top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: card.hoverColor,
                    borderRadius: 8,
                    padding: '25px 15px 15px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}>
                    <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: 16, lineHeight: 1.5, margin: 0, textAlign: 'center' }}>{card.hoverText}</p>
                    <Button
                        style={{
                            width: 172,
                            height: 34,
                            borderRadius: 5,
                            backgroundColor: 'rgba(255, 255, 255, 1)',
                            color: card.bgColor,
                            border: 'none',
                            fontWeight: 500,
                            marginTop: 14,
                        }}
                        onClick={card.action}>Click to View Document</Button>
                </div>
            )}
        </div>
    );
    // }
}

export default ComplianceCard;